import React from 'react';
import {sx} from "./sx";
import {Box} from "@mui/material";
import PointsReordersMutateSingleVoyageModal
    from "@containers/singleVoyage/mutateVoyage/points/pointsReorders/PointsReordersMutateSingleVoyageModal";

const HeaderRootSidebarMutateSingleVoyage = () => {

    return (
        <Box
            sx={sx.inner}
        >
            <PointsReordersMutateSingleVoyageModal/>
        </Box>
    );
};

export default HeaderRootSidebarMutateSingleVoyage;